/* Common Imports */

import React, { useState, useEffect } from "react";
import loadable from "@loadable/component";

/* Component Imports */

import Layout from "../../components/layout-components/Layout";
import SectionOne from "../../components/page-sections/reports/SectionOne";
import AppConfig from "../../AppConfig";

const SectionThree = loadable(() =>
  import("../../components/page-sections/reports/SectionThree")
);
const SectionFive = loadable(() =>
  import("../../components/page-sections/index/SectionFive")
);

const Reports = () => {
  const [reportss, setReportss] = useState([]);

  useEffect(() => {
    fetch(AppConfig.apiUrlPrefix + "reports")
      .then((r) => r.json())
      .then((d) => {
        setReportss(d.reports_head);
      })
      .catch((e) => console.error(e));
  }, []);
  return (
    <React.Fragment>
      <Layout>
        {reportss.map((reportHead, key) => {
          return (
            <SectionOne
              key={key}
              heading={
                reportHead.heading
                  ? reportHead.heading
                  : "Detailed reports for an efficient business"
              }
              subHeading={
                reportHead.subHeading
                  ? reportHead.subHeading
                  : "Leverage our customized cloud strategy to maximize the benefits of cloud computing"
              }
              btnLabel={reportHead.btnLabel ? reportHead.btnLabel : "Know More"}
              btnHref={reportHead.btnHref ? reportHead.btnHref : "#"}
              illustration={
                reportHead.illustration
                  ? reportHead.illustration
                  : "/images/illustrations/reports/reports.svg"
              }
            />
          );
        })}
        <SectionThree />
        <SectionFive source="reports-page" />
      </Layout>
    </React.Fragment>
  );
};

export default Reports;
